export default {
  decode(token) {
    if (token.split('.').length < 2) {
      throw new Error(`jwt is malformed: ${token}`);
    }

    return JSON.parse(atob(token.split('.')[1]));
  },
};
